<template>
  <nav class="grey lighten-5">
    <div class="container">
      <div class="nav-wrapper">
        <a style="margin-left: 20px;" class="breadcrumb" href="#!">Admin</a>
        <a class="breadcrumb" href="#!">Index</a>

        <div style="margin-right: 20px;" id="timestamp" class="right"></div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'app-breadcrumb'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.nav-wrapper {
  a {
    color: black;
  }
}
.breadcrumb:before {
  color: black;
}
nav {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue